export enum UploadEnums {
  Fail = 'fail',
  Uploading = 'uploading',
  Success = 'success',
  Wait = 'wait',
  WaitUpload = 'wait-upload',
}
